<template>
  <div :class="{'d-flex' : showAvatar || !isMe, 'd-flex justify-content-end': (!showAvatar && isMe)||(showAvatar && isMe)}">
    <img v-if="!isMe && showAvatar" :src="globalData.setting?.live_chat?.avatar" alt="" class="avatar-content"/>
    <div v-else class="non-avatar"></div>
    <div v-if="msg.message.content.attachment_data.length === 1" v-b-tooltip="{ title: util.formatTime(msg.created_at), placement: isMe ? 'left' : 'right' }">
      <img :src="msg.message.content.attachment_data[0].url" alt="" class="one-image">
    </div>
    <div v-else class="d-flex flex-wrap" v-b-tooltip="{ title: util.formatTime(msg.created_at), placement: isMe ? 'left' : 'right' }">
      <div v-for="(attachment_data, index) in msg.message.content.attachment_data" :key="'image' + index">
        <img :src="attachment_data.url" alt="" class="more-image">
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/lib/util";
export default {
  name: 'MsgImage',
  computed: {
    util() {
      return util
    }
  },
  components: {},
  props: ['msg', 'cls', 'isMe', 'showAvatar'],
  created() {
  },
  data() {
    return {}
  },

  methods: {

  }

};
</script>

<style lang="scss" scoped>
.one-image{
  width: 160px;
  height: 160px;
  border-radius: 8px;
}
.more-image{
  width: 80px;
  height: 80px;
  border-radius: 8px;
  margin-right: 2px;
  margin-bottom: 2px;
}
</style>